import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import {
  ThemeProvider as MUIThemeProvider,
  createTheme,
  responsiveFontSizes,
  StyledEngineProvider,
} from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';

ThemeProvider.propTypes = {
  children: PropTypes.node,
  darkMode: PropTypes.bool.isRequired,
};

export default function ThemeProvider({ children, darkMode }) {
  const theme = useMemo(() => {
    const selectedPalette = palette(darkMode ? 'dark' : 'light');

    let baseTheme = createTheme({
      palette: selectedPalette,
      shape: { borderRadius: 8 },
      typography,
      shadows,
      customShadows,
    });

    // 👇 make typography responsive automatically
    baseTheme = responsiveFontSizes(baseTheme);

    // apply component overrides
    baseTheme.components = componentsOverride(baseTheme);

    return baseTheme;
  }, [darkMode]);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
